import React from 'react';
import Input from 'react-toolbox/lib/input';
import { Card, CardText, CardActions } from 'react-toolbox/lib/card';
import { Button } from 'react-toolbox/lib/button';
import Dropdown from 'react-toolbox/lib/dropdown';
import { connect } from 'react-redux';
import Checkbox from 'react-toolbox/lib/checkbox';
import Switch from 'react-toolbox/lib/switch';

import { updateUser } from '~/actions/user';
import Styles from './users.scss';

const levels = [
  { value: 10, label: 'Admin' },
  { value: 1500, label: 'Manager' },
  { value: 2000, label: 'Users' },
  { value: 2001, label: 'System' }
];
const statusList = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' }
];

const permissionsAvailable = {
  article_edit: true,
  article_move: true,
  article_verify: true,
  customer_edit: true,
  raw_material_edit: true,
  raw_material_move: true,
  raw_material_verify: true,
  order_edit: true,
  container_edit: true,
  recipe_edit: true,
  recipe_run: true,
  location_edit: true,
  action_edit: true,
  user_edit: true,
  transaction_view: true,
  work_start: true,
  import_3dcart: true,
};

class EditUser extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
    const { username, name, level, status, userId, permissions } = props.user;
    this.state = { username, password: '', name, level, status, userId, permissions: permissions || permissionsAvailable };
    this.setState();
  }

  update() {
    const { password, name, level, status, userId, permissions } = this.state;
    updateUser(
      this.props.dispatch,
      this.context.apiClient,
      userId,
      password,
      name,
      level,
      status,
      permissions,
    )
      .then(() => {
        this.props.done();
      })
      .catch(e => {
        console.log(e);
      });
  }
  render() {
    return (
      <div
        className={[Styles.cardBox, Styles[this.props.transition]].join(' ')}
      >
        <Card>
          <div className={Styles.orderTitle}>
            Edit user {this.state.username}
          </div>
          <CardText>
            <Input
              type="text"
              label="Name"
              value={this.state.name}
              onChange={e => this.setState({ name: e })}
            />
            <Input
              type="password"
              label="Password"
              value={this.state.password}
              onChange={e => this.setState({ password: e })}
            />
            <Dropdown
              label="Level"
              auto
              onChange={level => this.setState({ level })}
              source={levels}
              value={this.state.level}
            />{' '}
            <Dropdown
              label="Status"
              auto
              onChange={status => this.setState({ status })}
              source={statusList}
              value={this.state.status}
            />
            <div style={{ margin: '10px 0px 10px 0px' }}><b>Permissions</b></div>
            <Switch
              label="all"
              checked={this.state.permissions.all}
              onChange={v => {
                this.setState({ permissions: { ...this.state.permissions, all: v } });
              }}
            />
            {Object.keys(permissionsAvailable).map(p =>
              <Checkbox
                key={p}
                label={p}
                checked={this.state.permissions[p]}
                disabled={this.state.permissions.all}
                onChange={v => {
                  this.setState({ permissions: { ...this.state.permissions, [p]: v } });
                }}
              />
            )}
          </CardText>
          <CardActions>
            <Button
              label="Update"
              onClick={() => {
                this.update();
              }}
            />
          </CardActions>
        </Card>
      </div>
    );
  }
}
// Setting pure: false is required for react router to work
export default connect(null, null, null, { pure: false })(EditUser);



// WEBPACK FOOTER //
// ./app/pages/Admin/edit.js